const MapServiceProviders = [
  {
    id: "OS",
    gpText: "Ordnance Survey",
    osText: "Ordnance Survey",
  },
  {
    id: "viaEuropa",
    gpText: undefined,
    osText: "viaEuropa",
  },
  {
    id: "thinkWare",
    gpText: "thinkWhere",
    osText: "thinkWhere",
  },
  {
    id: "customer",
    gpText: "Customer Provided",
    osText: "Customer Provided",
  },
  {
    id: "Jersey",
    gpText: "Jersey Government",
    osText: undefined,
  },
];

export default MapServiceProviders;
